module.exports = __webpack_public_path__ + "img/cent-fhr.5376fa9a.png";